// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-p_eV","galleryItem_borderTopRadius":"c-p_eW","galleryItem__image":"c-p_eX"};